import * as React from 'react';
import { connect } from 'react-redux';
import * as microsoftTeams from "@microsoft/teams-js";
import { useHistory } from 'react-router';
import { BrowserStorageKey } from '../../constant/storage';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import moment from 'moment';
import appSetting from '../../utils/appSetting';

const Boot = () => {
    const history = useHistory();
    const {
        teamEvent
    } = useTypedSelector((state: ApplicationState) => state.meeting);
    const [loadingData, setLoadingData] = React.useState("Please wait");
    React.useEffect(() => {
        try {
            const token = localStorage.getItem(BrowserStorageKey.ACCESS_TOKEN);
            if (!!token && token.length > 10) {
                microsoftTeams.getContext(({ entityId, frameContext, chatId }) => {//replaced meetingId with ChatId
                    if (!(chatId && chatId.length > 5) || entityId === 'myMeetings') {
                        history.push('/mymeetings');
                    }
                    else if (frameContext && frameContext === 'sidePanel') {
                        history.push('/inmeeting');
                    }
                    else if (!appSetting.isAppConfigured()) {
                        if (chatId && chatId.length > 5) {
                            history.push('/configure');
                        } else {
                            history.push("/notavailable")
                        }
                    }
                    else {
                        if (teamEvent && teamEvent.end) {
                            setLoadingData(teamEvent.id);
                            const end = teamEvent.end.dateTime + 'Z';
                            const date = moment(end).valueOf();
                            const now = moment.now().valueOf();
                            if (date < now) {
                                history.push('/postmeeting');
                            } else {
                                history.push('/premeeting');
                            }
                        } else {
                            history.push('/premeeting');
                        }
                    }
                });
            }
            else {
                microsoftTeams.getContext(({ entityId, chatId }) => {
                    if (chatId && chatId.length > 5 ) {
                        history.push('/login');
                    }
                    else if (!(chatId && chatId.length > 5) || entityId === 'myMeetings')
                    {
                        history.push('/login');
                    }
                    else {
                        history.push("/notavailable")
                    }
                });
            }
        } catch (ex) {
            setLoadingData(ex);
        }
    }, []);
    return (
        <div>
            {loadingData}
        </div>
    )
};

export default connect()(Boot);
